import {ServiceLog} from "./serviceLog";
import {FileData} from "./fileData";
import {User} from "./user";
import {MembershipType} from "./membershipType";

export class Dog {
    id: string;
    name: string;
    birthday: Date;
    deathDate: Date;
    race: string;
    sterilized: boolean;
    membershipDate: Date;
    membershipRenewalDate: Date;
    membershipActive: boolean;
    membershipOut: Date;
    membershipTypeId: string;
    membershipType: MembershipType;
    gender: string;
    ownerId: string;
    ownerName: string;
    owner: User;
    avatar: FileData;
    services: ServiceLog[];
    bundles: [any];
    membershipTypeLogs: any[]

    constructor(data = {
        id: null,
        name: null,
        birthday: null,
        race: null,
        sterilized: false,
        membershipDate: new Date(),
        membershipRenewalDate: new Date(),
        membershipActive: false,
        membershipOut: null,
        membershipType: null,
        gender: null,
        ownerName: ''
    }) {
        this.id = data.id;
        this.name = data.name;
        this.birthday = data.birthday;
        this.race = data.race;
        this.sterilized = data.sterilized;
        this.membershipDate = data.membershipDate;
        this.membershipRenewalDate = data.membershipRenewalDate;
        this.membershipActive = data.membershipActive;
        this.membershipOut = data.membershipOut;
        this.membershipType = data.membershipType;
        this.gender = data.gender;
        this.ownerName = data.ownerName;
    }
}



// WEBPACK FOOTER //
// ./src/classes/dog.ts